module.exports = "<span class=\"link\" (click)=\"onClicked($event);\">\n    <ng-content></ng-content>\n</span>";


//////////////////
// WEBPACK FOOTER
// ./src/typescript/coverage-modal/coverage-modal-link.component.html
// module id = 1084
// module chunks = 1